import React from "react";

export default function ArtChallenges({ challenges }) {
  return (
    <div className="grid grid-cols-2 gap-4">
      {challenges.map((challenge) => (
        <div key={challenge.id} className="border rounded-lg p-4 shadow">
          <h3>Défi : {challenge.theme}</h3>
          <div className="grid grid-cols-2 gap-2">
            {challenge.submissions.map((submission) => (
              <div key={submission.title}>
                <img src={submission.image} alt={submission.title} className="w-full h-32 object-cover rounded" />
                <p>{submission.title} - {submission.artist}</p>
              </div>
            ))}
          </div>
          <button className="mt-2 bg-blue-500 text-white px-4 py-2 rounded">Participer</button>
        </div>
      ))}
    </div>
  );
}
